import { setupWorker } from "msw"
import { handlers } from "./handlers"

const worker = setupWorker(...handlers)
export const mock = {
  start: () => {
    worker.start({
      onUnhandledRequest: "warn",
    })
  },
}

if (window) {
  // @ts-expect-error: msw is not defined on window
  window.msw = {
    mock,
    worker,
  }
}
